import { graphql } from '@/graphql/generated/seller';

export const asnsQuery = graphql(`
  query AsnsQuery($limit: Int!, $offset: Int!, $where: AsnsBoolExp!, $orderBy: [AsnsOrderByExp!]!) {
    asns(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
      id
      name
      reference
      expectedAt
      locationName
      status
      qtyExpected
      qtyReceived
      closedAt
      createdAt
    }
    asnsAggregate(filter_input: { where: $where }) {
      _count
    }
  }
`);
